const MAX_ARTICLE_HEIGHT = 300;
const MAX_ARTICLE_HEIGHT_ATTACHMENTS = 200;

class MaskArticleCtrl {
  constructor($element, $scope, $window) {
    'ngInject';

    Object.assign(this, { $element, $scope, $window });
  }

  expanded = false;
  shouldMask = false;
  maxHeight = MAX_ARTICLE_HEIGHT;

  $onInit() {
    if (this.hasAttachments) {
      this.maxHeight = MAX_ARTICLE_HEIGHT_ATTACHMENTS;
    }

    setTimeout(this.checkMaskState, 0);
  }

  checkMaskState = () => {
    const height = this.getElementHeight();
    this.shouldMask = height > MAX_ARTICLE_HEIGHT;

    if (!this.shouldMask) {
      this.onReveal?.(this.id);
    }
  };

  getElementHeight = () => {
    const computedStyleHeight = this.$window.getComputedStyle(this.$element.children()[0]).height;
    if (computedStyleHeight && /px$/.test(computedStyleHeight)) {
      return Number(computedStyleHeight.slice(0, -2));
    }

    this.$element.children()[0].offsetheight;
  };

  expand = () => {
    this.expanded = true;
    this.onReveal?.(this.id);
  };

  get isMaskActive() {
    return !this.expanded && this.shouldMask;
  }
}

export default {
  controllerAs: 'ctrl',
  bindings: {
    hasAttachments: '<',
    onReveal: '=',
    id: '<',
  },
  template: `
  <div>
    <div ng-transclude
      class="overflow-hidden" ng-style="ctrl.isMaskActive && {'max-height':  ctrl.maxHeight + 'px'}"
      ng-class="{'article-mask': ctrl.isMaskActive}"
      ></div>
    <span ng-show="ctrl.isMaskActive">... <a class="see-more" ng-click="ctrl.expand()">See more</a></span>
  <div>`,
  transclude: true,
  controller: MaskArticleCtrl,
};
